const PATH_ENTRYPOINTS = {
    devadmin: "/devadmin",
    assessments: "/assessments",
    "writing-coach": "/writing-coach",
};

export function shouldReload(entrypoint: string, pathname: string) {
    // If we're attempting to render a page that doesn't exist inside our
    // entrypoint, then we need to reload the page instead of rendering
    // to force the user to the correct entrypoint.
    if (PATH_ENTRYPOINTS[entrypoint]) {
        return !pathname.startsWith(PATH_ENTRYPOINTS[entrypoint]);
    }

    return Object.values(PATH_ENTRYPOINTS).some((path) =>
        pathname.startsWith(path),
    );
}

export const exportedForTesting = {PATH_ENTRYPOINTS};
